export default __webpack_public_path__ + "static/media/rangetubeImg_1.84b142e8.webp";